import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'VOICE_UPDATE',
    smsDelete : 'VOICE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        
        voice:[],
        submitLoading: false,
        voiceLoading: false,
        voiceError: false,
        ...store
    },

    mutations : {
        ...mutations,
       
        SET_VOICE(state, voice) {
            state.voice = voice;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        VOICE_LOADING (state, loading) {
            state.voiceLoading = loading;
        },
        VOICE_ERROR (state, hasError) {
            state.voiceError = hasError;
        },
        
    },

    actions: {


        async fetchVoice ({ commit }) {
            commit('VOICE_LOADING', true);
            commit('VOICE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_voice_list, config);
                let response = result.data

                commit('SET_VOICE', response.data);

            } catch(error) {
                commit('VOICE_ERROR', true);
            }
            finally {
                commit('VOICE_LOADING', false);
            }
        },



        async deleteNews({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.news_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchNews')
            
            return response
        },





       








    },

    getters: {}
}
